import { render, staticRenderFns } from "./UpdateButton.vue?vue&type=template&id=05d8be24&scoped=true"
import script from "./UpdateButton.vue?vue&type=script&lang=ts"
export * from "./UpdateButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d8be24",
  null
  
)

export default component.exports